module.exports = __webpack_public_path__ + "static/media/thumbnail.eb4a5252.jpg";